import createClient, { type Client, type ClientOptions } from 'openapi-fetch';

import type { ClientMiddleware } from './types.js';

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- intentionally untyped client for non-schema routes
export type UntypedApiClient = Client<any, any>;
export type TypedApiClient<TPaths extends object> = Client<TPaths>;

export type ApiClientPair<TPaths extends object> = {
  typed: TypedApiClient<TPaths>;
  untyped: UntypedApiClient;
};

export const createApiClients = <TPaths extends object>(
  options: ClientOptions,
  middlewares: ClientMiddleware[] = []
): ApiClientPair<TPaths> => {
  const typed = createClient<TPaths>(options);
  const untyped = createClient(options) as UntypedApiClient;

  if (middlewares.length > 0) {
    typed.use(...middlewares);
    untyped.use(...middlewares);
  }

  return { typed, untyped };
};
